"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tavernerio": {
    "f04febf9": [{
      "hkey": "7a4fd847",
      "slug": "tavernerio",
      "name": "Tavernerio",
      "primary": true,
      "skipSearch": false
    }],
    "caslascio": [{
      "hkey": "7a4fd847",
      "slug": "tavernerio",
      "name": "Tavernerio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "796112d8": [{
      "hkey": "25ea7daa",
      "slug": "urago",
      "name": "Urago",
      "primary": true,
      "skipSearch": false
    }],
    "crotto-di-urago": [{
      "hkey": "25ea7daa",
      "slug": "urago",
      "name": "Urago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tavernerio"
    }],
    "7fe23c29": [{
      "hkey": "7a4fd847",
      "slug": "tavernerio",
      "name": "Tavernerio",
      "primary": true,
      "skipSearch": false
    }],
    "gilasca": [{
      "hkey": "7a4fd847",
      "slug": "tavernerio",
      "name": "Tavernerio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f4d2124": [{
      "hkey": "d07eb5fe",
      "slug": "solzago-ponzate",
      "name": "Solzago-Ponzate",
      "primary": true,
      "skipSearch": false
    }],
    "ponzate": [{
      "hkey": "d07eb5fe",
      "slug": "solzago-ponzate",
      "name": "Solzago-Ponzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tavernerio"
    }],
    "e1da4aa2": [{
      "hkey": "a7040759",
      "slug": "centro-rovascio",
      "name": "Centro-Rovascio",
      "primary": true,
      "skipSearch": false
    }],
    "rovascio": [{
      "hkey": "a7040759",
      "slug": "centro-rovascio",
      "name": "Centro-Rovascio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8e2ee0ad": [{
      "hkey": "d07eb5fe",
      "slug": "solzago-ponzate",
      "name": "Solzago-Ponzate",
      "primary": true,
      "skipSearch": false
    }],
    "solzago": [{
      "hkey": "d07eb5fe",
      "slug": "solzago-ponzate",
      "name": "Solzago-Ponzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;